import * as types from "../actions/actionTypes";

const byTitle = (a, b) => a.Title.localeCompare(b.Title);

export const initialLibraryState = {
  searchValue: "",
  songs: [],
  isLoaded: false,
  loadFailed: false, // the last load got no answer; cleared by the next successful one
};

export default function libraryReducer(state = initialLibraryState, action) {
  switch (action.type) {
    case types.LIBRARY_SEARCH_CHANGE:
      return { ...state, searchValue: action.searchValue };

    case types.LIBRARY_LOAD_SUCCESS:
      return { ...state, songs: [...action.songs].sort(byTitle), isLoaded: true, loadFailed: false };

    case types.LIBRARY_LOAD_FAILED:
      return { ...state, isLoaded: true, loadFailed: true };

    case types.LIBRARY_SONG_ADDED: {
      const songs = state.songs.filter((song) => song.Id !== action.song.Id);
      return { ...state, songs: [...songs, action.song].sort(byTitle) };
    }

    case types.SONG_UPDATED:
      return { ...state, songs: state.songs.map((song) => (song.Id === action.song.Id ? action.song : song)).sort(byTitle) };

    case types.SONG_DELETED:
      return { ...state, songs: state.songs.filter((song) => song.Id !== action.songId) };

    case types.LIBRARY_SONG_REMOVED:
      return { ...state, songs: state.songs.filter((song) => song.Id !== action.songId) };

    default:
      return state;
  }
}
